import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/region-codes/create',
    name: 'regionCodeCreate',
    component: () => import('@/views/restricted/others/region-code/RegionCodeCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_DISTRIBUTOR_NETWORK_CREATE_PERMISSION'],
      menuSelected: 'others'
    }
  },
  {
    path: '/region-codes/:regionCodeId/edit',
    name: 'regionCodeUpdate',
    component: () => import('@/views/restricted/others/region-code/RegionCodeUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_DISTRIBUTOR_NETWORK_UPDATE_PERMISSION'],
      menuSelected: 'others'
    }
  }
]
